<template>
  <div class="page-view reset">
    <div class="container">
      <h1 class="page-title">Recupero password</h1>
      <h3 class="subtitle" v-if="msg">
        {{ msg }}
      </h3>
      <div class="form-wrapper">
        <Form @submit="tryRecovery">
          <Field name="email" rules="req|email" type="email" placeholder="Inserisci il tuo indirizzo mail"/>
          <ErrorMessage name="email" />
          <button type="submit" class="btn submit">
            Invia
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Form, ErrorMessage } from 'vee-validate'

export default {
  components: {
    Field,
    Form,
    ErrorMessage
  },
  data () {
    return {
      msg: null
    }
  },
  methods: {
    async tryRecovery (values) {
      console.log('tryRecovery', values)
      let msg = ''
      const recovery = await this.$store.dispatch('recoverPassword', {
        email: values.email
      })
      console.log('recovery', recovery)
      if (recovery) {
        const error = false
        msg = 'RICHIESTA inviata correttamente: controlla la tua casella di posta.'
        this.emitter.emit('fireAlert', { msg, error })
      } else {
        const error = true
        msg = 'ERRORE durante la richiesta: ripetere la procedura.'
        this.emitter.emit('fireAlert', { msg, error })
      }
      this.msg = msg
    }
  }
}
</script>

<style scoped lang="scss">
  // @import "@/assets/scss/views/reset.scss";
  @import "@/assets/scss/forms.scss";

  .form-wrapper {
    @apply
      max-w-lg
      mt-4;
  }
</style>
